import * as React from 'react';
import type {DateRange} from 'react-day-picker';

export function useRangeMonthSync(value: DateRange | undefined) {
  const isPreloadedRef = React.useRef(false);
  const [month, setMonth] = React.useState<Date>(value?.from ?? new Date());

  React.useEffect(() => {
    if (value?.from && !isPreloadedRef.current) {
      setMonth(value.from);
      isPreloadedRef.current = true;
    }
  }, [value?.from]);

  const syncMonthToValue = React.useCallback((next: DateRange | undefined) => {
    isPreloadedRef.current = true;
    if (next?.from) setMonth(next.from);
  }, []);

  const resetPreload = React.useCallback(() => {
    isPreloadedRef.current = false;
  }, []);

  return {month, setMonth, syncMonthToValue, resetPreload};
}
